import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}

import { AssetManagementPlan } from "@/classes";
import RichText from "@/components/base/inputs/RichText.vue";
import LinkTable from "../links/LinkTable.vue";
import PM02PM03Chart from "@/components/metrics/PM02PM03Chart.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffServiceLevelKPIs',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.work_management_metrics ?? '',
      "diff-value": _ctx.diffPlan?.work_management_metrics,
      label: "6.1 Work Management Metrics",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(LinkTable, {
      class: "mb-4",
      label: "6.1.1 Work Management Metrics Links",
      links: _ctx.plan?.work_management_metrics_links ?? [],
      readonly: ""
    }, null, 8, ["links"]),
    _createVNode(RichText, {
      class: "mb-4",
      "model-value": _ctx.plan?.reliability_metrics ?? '',
      "diff-value": _ctx.diffPlan?.reliability_metrics,
      label: "6.2 Reliability Metrics",
      readonly: "",
      options: { diff: _ctx.diff }
    }, null, 8, ["model-value", "diff-value", "options"]),
    _createVNode(LinkTable, {
      class: "mb-4",
      label: "6.2.1 Reliability Metrics Links",
      links: _ctx.plan?.reliability_metrics_links ?? [],
      readonly: ""
    }, null, 8, ["links"]),
    _createVNode(_component_v_card, {
      variant: "outlined",
      rounded: "lg"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_toolbar, { density: "compact" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode("6.3 PM02/PM03")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(PM02PM03Chart, {
          class: "pa-3",
          "hide-title": "",
          "chart-height": "500px",
          "floc-ids": 
          _ctx.plan ? _ctx.plan.floc_boundaries.map((b) => b.functional_location_id) : []
        
        }, null, 8, ["floc-ids"])
      ]),
      _: 1
    })
  ]))
}
}

})